"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBalancePlus = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M4 2a2 2 0 00-2 2v16a2 2 0 002 2h8.81A6.478 6.478 0 0111 17.5a6.498 6.498 0 013.322-5.671c-.12-.587-.311-.99-.488-1.364-.228-.484-.434-.919-.434-1.641a2.824 2.824 0 015.647 0c0 .534-.083 1.365-.22 2.312A6.485 6.485 0 0122 12.81V4a2 2 0 00-2-2H4zm6.213 8.465c.229-.484.434-.919.434-1.641a2.824 2.824 0 00-5.647 0c0 1.127.369 3.576.84 5.647h3.837c-.247-2.35.174-3.24.536-4.006zm-.336 5.417h-3.68c.07.253.143.49.215.706.156.47.706 1.412 1.764 1.412 1.06 0 1.807-1.059 1.765-1.765l-.064-.353z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M17.5 22a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm.75-2.25a.75.75 0 01-1.5 0v-1.5h-1.5a.75.75 0 010-1.5h1.5v-1.5a.75.75 0 011.5 0v1.5h1.5a.75.75 0 010 1.5h-1.5v1.5z' }))); };
exports.default = SvgBalancePlus;
//# sourceMappingURL=BalancePlus.js.map